import Vue from 'vue';
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';

Vue.component('splitpanes', Splitpanes);
Vue.component('pane', Pane);
